import Vue from 'vue';

import { get, pick } from '@/helpers';

const state = {
  list: []
};

const getters = {
  list: state => state.list
};

const actions = {
  add({ commit, state }, message) {
    const messages = get(state, 'list', []);
    const i = messages.length;

    const search = pick(message, ['title', 'text', 'info', 'type']);
    const existing = messages.findIndex(el => {
      return el.title === search.title && el.text === search.text && el.info === search.info && el.type === search.type;
    });

    if (existing >= 0) {
      commit('set', { i: existing, key: 'autoclose', value: get(message, 'autoclose', 5000) });
      commit('set', { i: existing, key: 'highlight', value: true });
      setTimeout(() => {
        if (get(state.list[existing], 'highlight')) commit('set', { i: existing, key: 'highlight', value: false });
      }, 200);
    } else {
      commit('add', { i, message });
    }
  }
};

const mutations = {
  add(state, { i, message }) {
    Vue.set(state.list, i, message);
  },
  set(state, { i, key, value }) {
    Vue.set(state.list[i], key, value);
  },
  remove(state, id) {
    const i = state.list.findIndex(message => message.id === id);

    if (i !== -1) {
      Vue.delete(state.list, i);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
